export const formItemLayout = {
	labelCol: { xs: { span: 24 }, sm: { span: 8 } },
	wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
};

export const formItemLayoutWide = {
	labelCol: { xs: { span: 24 }, sm: { span: 4 } },
	wrapperCol: { xs: { span: 24 }, sm: { span: 20 } },
};

export const tailFormItemLayout = {
	wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 16, offset: 8 } },
};

export const getRequiredRule = (message) => ({ required: true, message });

export const getDateRule = (message) => ({
	pattern: /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/,
	message,
});

export const getDateValidateStatus = (input) => {
	return 'error';
};

export const getStringSorter = (attribute) => {
	return (a, b) => {
		return (a[attribute] || '').localeCompare(b[attribute], 'sv', { sensitivity: 'base' });
	};
};

export const getIntSorter = (attribute) => {
	return (a, b) => {
		return (a[attribute] || 0) - (b[attribute] || 0);
	};
};

export const getBooleanSorter = (attribute) => {
	return (a, b) => {
		return a[attribute]
			.toString()
			.localeCompare(b[attribute].toString(), undefined, { numeric: true });
	};
};



// WEBPACK FOOTER //
// ./src/utils/antUtils.js